var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "article",
    {
      staticClass: "advantage-item d-flex ga-4 text-break",
      attrs: { "data-qa": "advantage_item" },
    },
    [
      _vm.advantage.icon.icon.url
        ? _c(
            "div",
            {
              staticClass:
                "advantage-item__icon-wrap d-flex align-center justify-center flex-shrink-0 rounded-15 bg-lpu-branding-color-primary",
            },
            [
              _c(_setup.MaskIcon, {
                staticClass: "advantage-item__icon",
                attrs: {
                  "data-qa": "advantage_item_icon",
                  src: _vm.advantage.icon.icon.url,
                  size: 21.3,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-column ga-1" }, [
        _c(
          "h3",
          {
            staticClass: "text-subtitle-1 text--text",
            attrs: { "data-qa": "advantage_item_title" },
          },
          [_vm._v("\n      " + _vm._s(_vm.advantage.title) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass: "text-body-2 text-secondary--text",
            attrs: { "data-qa": "advantage_item_description" },
          },
          [_vm._v("\n      " + _vm._s(_vm.advantage.description) + "\n    ")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }